import React from 'react'
import {Form} from "@redriver/cinnamon";

const NonPropagatingTextArea = (props) => {
    return (
        <Form.TextArea {...props} onKeyDown={(e) => e.stopPropagation()}/>
    )
}
export default NonPropagatingTextArea
